import type { PublicSlotKey } from '#packages/apilib';
import type { DataBindingApi } from './dataBinding';

export const DataBindingApiKey: PublicSlotKey<DataBindingApi> = {
  name: 'DataBindingApi',
  public: true,
};
